export const SUBMIT_PARTNER_APPLICATION = gql`
    mutation SubmitPartnerApplication($applicationId: Int!) {
        submitPartnerApplication(applicationId: $applicationId)
    }
`;

export const DELETE_PARTNER_APPLICATION = gql`
    mutation DeletePartnerApplication($applicationId: Int!) {
        deletePartnerApplication(applicationId: $applicationId)
    }
`;
